import type { Address } from '@/modules/address/domain/Address';
import useRegions from '@/sections/region/hooks/useRegions';

export const UseFindLocation = () => {
  const { data: regions } = useRegions();

  const find = (address: Omit<Address, 'id'>) => {
    const region = regions?.find(({ id }) => address?.region === id);
    let commune = null;
    if (region) {
      commune = region?.communes?.find(
        (commune) => address?.commune === commune?.code
      );
      if (commune) {
        return { selectedRegion: region, selectedCommune: commune };
      }
    }
    return { selectedRegion: null, selectedCommune: null };
  };

  return { find };
};
